module.exports = __webpack_public_path__ + "static/media/vskit.9cf75925.svg";